export interface Country {
  key: string;
  label: string;
  types?: {
    id: string;
    validations: {
      regex: RegExp;
      examples: string[];
      prepend?: string;
      append?: string;
    }[];
  }[];
  eu?: boolean;
}

const countries: Country[] = [
  {
    key: "AF",
    label: "Afghanistan",
  },
  {
    key: "AX",
    label: "Aland Islands",
  },
  {
    key: "AL",
    label: "Albania",
  },
  {
    key: "DZ",
    label: "Algeria",
  },
  {
    key: "AS",
    label: "American Samoa",
  },
  {
    key: "AD",
    label: "Andorra",
  },
  {
    key: "AO",
    label: "Angola",
  },
  {
    key: "AI",
    label: "Anguilla",
  },
  {
    key: "AQ",
    label: "Antarctica",
  },
  {
    key: "AG",
    label: "Antigua and Barbuda",
  },
  {
    key: "AR",
    label: "Argentina",
    types: [
      {
        id: "ar_cuit",
        validations: [
          {
            regex: /^(\d{2}-\d{7}-\d{2})$/,
            examples: ["12-3456789-01"],
          },
        ],
      },
    ],
  },
  {
    key: "AM",
    label: "Armenia",
  },
  {
    key: "AW",
    label: "Aruba",
  },
  {
    key: "AU",
    label: "Australia",
  },
  {
    key: "AT",
    label: "Austria",
    eu: true,
    types: [
      {
        id: "eu_vat",
        validations: [
          {
            regex: /^(ATU\d{8})$/,
            examples: ["ATU12345678"],
            prepend: "ATU",
          },
        ],
      },
    ],
  },
  {
    key: "AZ",
    label: "Azerbaijan",
  },
  {
    key: "BS",
    label: "Bahamas",
  },
  {
    key: "BH",
    label: "Bahrain",
  },
  {
    key: "BD",
    label: "Bangladesh",
  },
  {
    key: "BB",
    label: "Barbados",
  },
  {
    key: "BY",
    label: "Belarus",
  },
  {
    key: "BE",
    label: "Belgium",
  },
  {
    key: "BZ",
    label: "Belize",
  },
  {
    key: "BJ",
    label: "Benin",
  },
  {
    key: "BM",
    label: "Bermuda",
  },
  {
    key: "BT",
    label: "Bhutan",
  },
  {
    key: "BO",
    label: "Bolivia",
    /* types: [
      {
        id: 'bo_tin',
        validations: [
          {
            regex: /^(\d{9})$/,
            examples: ['123456789'],
          },
        ],
      },
    ], */
  },
  {
    key: "BQ",
    label: "Bonaire, Saint Eustatius and Saba ",
  },
  {
    key: "BA",
    label: "Bosnia and Herzegovina",
  },
  {
    key: "BW",
    label: "Botswana",
  },
  {
    key: "BV",
    label: "Bouvet Island",
  },
  {
    key: "BR",
    label: "Brazil",
  },
  {
    key: "IO",
    label: "British Indian Ocean Territory",
  },
  {
    key: "VG",
    label: "British Virgin Islands",
  },
  {
    key: "BN",
    label: "Brunei",
  },
  {
    key: "BG",
    label: "Bulgaria",
  },
  {
    key: "BF",
    label: "Burkina Faso",
  },
  {
    key: "BI",
    label: "Burundi",
  },
  {
    key: "KH",
    label: "Cambodia",
  },
  {
    key: "CM",
    label: "Cameroon",
  },
  {
    key: "CA",
    label: "Canada",
  },
  {
    key: "CV",
    label: "Cape Verde",
  },
  {
    key: "KY",
    label: "Cayman Islands",
  },
  {
    key: "CF",
    label: "Central African Republic",
  },
  {
    key: "TD",
    label: "Chad",
  },
  {
    key: "CL",
    label: "Chile",
    types: [
      {
        id: "cl_tin",
        validations: [
          {
            regex: /^(\d{2}\.\d{3}\.\d{3}-[\dK])$/,
            examples: ["12.345.678-K"],
          },
        ],
      },
    ],
  },
  {
    key: "CN",
    label: "China",
  },
  {
    key: "CX",
    label: "Christmas Island",
  },
  {
    key: "CC",
    label: "Cocos Islands",
  },
  {
    key: "CO",
    label: "Colombia",
    types: [
      {
        id: "co_nit",
        validations: [
          {
            regex: /^(\d{3}\.\d{3}\.\d{3}-\d)$/,
            examples: ["123.456.789-0"],
          },
        ],
      },
    ],
  },
  {
    key: "KM",
    label: "Comoros",
  },
  {
    key: "CK",
    label: "Cook Islands",
  },
  {
    key: "CR",
    label: "Costa Rica",
  },
  {
    key: "HR",
    label: "Croatia",
  },
  {
    key: "CU",
    label: "Cuba",
  },
  {
    key: "CW",
    label: "Curacao",
  },
  {
    key: "CY",
    label: "Cyprus",
  },
  {
    key: "CZ",
    label: "Czech Republic",
  },
  {
    key: "CD",
    label: "Democratic Republic of the Congo",
  },
  {
    key: "DK",
    label: "Denmark",
  },
  {
    key: "DJ",
    label: "Djibouti",
  },
  {
    key: "DM",
    label: "Dominica",
  },
  {
    key: "DO",
    label: "Dominican Republic",
  },
  {
    key: "TL",
    label: "East Timor",
  },
  {
    key: "EC",
    label: "Ecuador",
    /* types: [
      {
        id: 'ec_ruc',
        validations: [
          {
            regex: /^(\d{13})$/,
            examples: ['1234567890001'],
          },
        ],
      },
    ], */
  },
  {
    key: "EG",
    label: "Egypt",
  },
  {
    key: "SV",
    label: "El Salvador",
    /* types: [
      {
        id: 'sv_nit',
        validations: [
          {
            regex: /^(\d{4}-\d{6}-\d{3}-\d)$/,
            examples: ['1234-567890-123-4'],
          },
        ],
      },
    ],*/
  },
  {
    key: "GQ",
    label: "Equatorial Guinea",
  },
  {
    key: "ER",
    label: "Eritrea",
  },
  {
    key: "EE",
    label: "Estonia",
  },
  {
    key: "ET",
    label: "Ethiopia",
  },
  {
    key: "FK",
    label: "Falkland Islands",
  },
  {
    key: "FO",
    label: "Faroe Islands",
  },
  {
    key: "FJ",
    label: "Fiji",
  },
  {
    key: "FI",
    label: "Finland",
  },
  {
    key: "FR",
    label: "France",
    eu: true,
    types: [
      {
        id: "eu_vat",
        validations: [
          {
            regex: /^(PT[A-Z]{2}\d{9})$/,
            examples: ["FRAB123456789"],
            prepend: "PT",
          },
        ],
      },
    ],
  },
  {
    key: "GF",
    label: "French Guiana",
  },
  {
    key: "PF",
    label: "French Polynesia",
  },
  {
    key: "TF",
    label: "French Southern Territories",
  },
  {
    key: "GA",
    label: "Gabon",
  },
  {
    key: "GM",
    label: "Gambia",
  },
  {
    key: "GE",
    label: "Georgia",
  },
  {
    key: "DE",
    label: "Germany",
    eu: true,
    types: [
      {
        id: "eu_vat",
        validations: [
          {
            regex: /^(DE\d{9})$/,
            examples: ["DE123456789"],
            prepend: "DE",
          },
        ],
      },
      {
        id: "de_stn",
        validations: [
          {
            regex: /^(\d{10})$/,
            examples: ["1234567890"],
          },
        ],
      },
    ],
  },
  {
    key: "GH",
    label: "Ghana",
  },
  {
    key: "GI",
    label: "Gibraltar",
  },
  {
    key: "GR",
    label: "Greece",
  },
  {
    key: "GL",
    label: "Greenland",
  },
  {
    key: "GD",
    label: "Grenada",
  },
  {
    key: "GP",
    label: "Guadeloupe",
  },
  {
    key: "GU",
    label: "Guam",
  },
  {
    key: "GT",
    label: "Guatemala",
  },
  {
    key: "GG",
    label: "Guernsey",
  },
  {
    key: "GN",
    label: "Guinea",
  },
  {
    key: "GW",
    label: "Guinea-Bissau",
  },
  {
    key: "GY",
    label: "Guyana",
  },
  {
    key: "HT",
    label: "Haiti",
  },
  {
    key: "HM",
    label: "Heard Island and McDonald Islands",
  },
  {
    key: "HN",
    label: "Honduras",
  },
  {
    key: "HK",
    label: "Hong Kong",
  },
  {
    key: "HU",
    label: "Hungary",
  },
  {
    key: "IS",
    label: "Iceland",
  },
  {
    key: "IN",
    label: "India",
  },
  {
    key: "ID",
    label: "Indonesia",
  },
  {
    key: "IR",
    label: "Iran",
  },
  {
    key: "IQ",
    label: "Iraq",
  },
  {
    key: "IE",
    label: "Ireland",
  },
  {
    key: "IM",
    label: "Isle of Man",
  },
  {
    key: "IL",
    label: "Israel",
  },
  {
    key: "IT",
    label: "Italia",
    eu: true,
    types: [
      {
        id: "eu_vat",
        validations: [
          {
            regex: /^(IT\d{11})$/,
            examples: ["IT12345678912"],
            prepend: "IT",
          },
        ],
      },
    ],
  },
  {
    key: "CI",
    label: "Ivory Coast",
  },
  {
    key: "JM",
    label: "Jamaica",
  },
  {
    key: "JP",
    label: "Japan",
  },
  {
    key: "JE",
    label: "Jersey",
  },
  {
    key: "JO",
    label: "Jordan",
  },
  {
    key: "KZ",
    label: "Kazakhstan",
  },
  {
    key: "KE",
    label: "Kenya",
  },
  {
    key: "KI",
    label: "Kiribati",
  },
  {
    key: "XK",
    label: "Kosovo",
  },
  {
    key: "KW",
    label: "Kuwait",
  },
  {
    key: "KG",
    label: "Kyrgyzstan",
  },
  {
    key: "LA",
    label: "Laos",
  },
  {
    key: "LV",
    label: "Latvia",
  },
  {
    key: "LB",
    label: "Lebanon",
  },
  {
    key: "LS",
    label: "Lesotho",
  },
  {
    key: "LR",
    label: "Liberia",
  },
  {
    key: "LY",
    label: "Libya",
  },
  {
    key: "LI",
    label: "Liechtenstein",
  },
  {
    key: "LT",
    label: "Lithuania",
  },
  {
    key: "LU",
    label: "Luxembourg",
  },
  {
    key: "MO",
    label: "Macao",
  },
  {
    key: "MK",
    label: "Macedonia",
  },
  {
    key: "MG",
    label: "Madagascar",
  },
  {
    key: "MW",
    label: "Malawi",
  },
  {
    key: "MY",
    label: "Malaysia",
  },
  {
    key: "MV",
    label: "Maldives",
  },
  {
    key: "ML",
    label: "Mali",
  },
  {
    key: "MT",
    label: "Malta",
    types: [
      {
        id: "eu_vat",
        validations: [
          {
            regex: /^(MT\d{8})$/,
            examples: ["MT12345678"],
            prepend: "MT",
          },
        ],
      },
    ],
  },
  {
    key: "MH",
    label: "Marshall Islands",
  },
  {
    key: "MQ",
    label: "Martinique",
  },
  {
    key: "MR",
    label: "Mauritania",
  },
  {
    key: "MU",
    label: "Mauritius",
  },
  {
    key: "YT",
    label: "Mayotte",
  },
  {
    key: "MX",
    label: "Mexico",
    types: [
      {
        id: "mx_rfc",
        validations: [
          {
            regex: /^(\d{13})$/,
            examples: ["1234567890001"],
          },
        ],
      },
    ],
  },
  {
    key: "FM",
    label: "Micronesia",
  },
  {
    key: "MD",
    label: "Moldova",
  },
  {
    key: "MC",
    label: "Monaco",
  },
  {
    key: "MN",
    label: "Mongolia",
  },
  {
    key: "ME",
    label: "Montenegro",
  },
  {
    key: "MS",
    label: "Montserrat",
  },
  {
    key: "MA",
    label: "Morocco",
  },
  {
    key: "MZ",
    label: "Mozambique",
  },
  {
    key: "MM",
    label: "Myanmar",
  },
  {
    key: "NA",
    label: "Namibia",
  },
  {
    key: "NR",
    label: "Nauru",
  },
  {
    key: "NP",
    label: "Nepal",
  },
  {
    key: "NL",
    label: "Netherlands",
  },
  {
    key: "NC",
    label: "New Caledonia",
  },
  {
    key: "NZ",
    label: "New Zealand",
  },
  {
    key: "NI",
    label: "Nicaragua",
  },
  {
    key: "NE",
    label: "Niger",
  },
  {
    key: "NG",
    label: "Nigeria",
  },
  {
    key: "NU",
    label: "Niue",
  },
  {
    key: "NF",
    label: "Norfolk Island",
  },
  {
    key: "KP",
    label: "North Korea",
  },
  {
    key: "MP",
    label: "Northern Mariana Islands",
  },
  {
    key: "NO",
    label: "Norway",
  },
  {
    key: "OM",
    label: "Oman",
  },
  {
    key: "PK",
    label: "Pakistan",
  },
  {
    key: "PW",
    label: "Palau",
  },
  {
    key: "PS",
    label: "Palestinian Territory",
  },
  {
    key: "PA",
    label: "Panama",
  },
  {
    key: "PG",
    label: "Papua New Guinea",
  },
  {
    key: "PY",
    label: "Paraguay",
  },
  {
    key: "PE",
    label: "Peru",
    types: [
      {
        id: "pe_ruc",
        validations: [
          {
            regex: /^(\d{11})$/,
            examples: ["12345678901"],
          },
        ],
      },
    ],
  },
  {
    key: "PH",
    label: "Philippines",
  },
  {
    key: "PN",
    label: "Pitcairn",
  },
  {
    key: "PL",
    label: "Poland",
  },
  {
    key: "PT",
    label: "Portugal",
    eu: true,
    types: [
      {
        id: "eu_vat",
        validations: [
          {
            regex: /^(PT\d{9})$/,
            examples: ["PT123456789"],
            prepend: "PT",
          },
        ],
      },
    ],
  },
  {
    key: "PR",
    label: "Puerto Rico",
  },
  {
    key: "QA",
    label: "Qatar",
  },
  {
    key: "CG",
    label: "Republic of the Congo",
  },
  {
    key: "RE",
    label: "Reunion",
  },
  {
    key: "RO",
    label: "Romania",
  },
  {
    key: "RU",
    label: "Russia",
  },
  {
    key: "RW",
    label: "Rwanda",
  },
  {
    key: "BL",
    label: "Saint Barthelemy",
  },
  {
    key: "SH",
    label: "Saint Helena",
  },
  {
    key: "KN",
    label: "Saint Kitts and Nevis",
  },
  {
    key: "LC",
    label: "Saint Lucia",
  },
  {
    key: "MF",
    label: "Saint Martin",
  },
  {
    key: "PM",
    label: "Saint Pierre and Miquelon",
  },
  {
    key: "VC",
    label: "Saint Vincent and the Grenadines",
  },
  {
    key: "WS",
    label: "Samoa",
  },
  {
    key: "SM",
    label: "San Marino",
  },
  {
    key: "ST",
    label: "Sao Tome and Principe",
  },
  {
    key: "SA",
    label: "Saudi Arabia",
  },
  {
    key: "SN",
    label: "Senegal",
  },
  {
    key: "RS",
    label: "Serbia",
  },
  {
    key: "SC",
    label: "Seychelles",
  },
  {
    key: "SL",
    label: "Sierra Leone",
  },
  {
    key: "SG",
    label: "Singapore",
  },
  {
    key: "SX",
    label: "Sint Maarten",
  },
  {
    key: "SK",
    label: "Slovakia",
  },
  {
    key: "SI",
    label: "Slovenia",
  },
  {
    key: "SB",
    label: "Solomon Islands",
  },
  {
    key: "SO",
    label: "Somalia",
  },
  {
    key: "ZA",
    label: "South Africa",
  },
  {
    key: "GS",
    label: "South Georgia and the South Sandwich Islands",
  },
  {
    key: "KR",
    label: "South Korea",
  },
  {
    key: "SS",
    label: "South Sudan",
  },
  {
    key: "ES",
    label: "España",
    eu: true,
    types: [
      {
        id: "eu_vat",
        validations: [
          {
            regex: /^(ES[A-Z]{1}\d{7}[A-Z\d]{1})$/,
            examples: ["ESA1234567Z", "A12345678"],
            prepend: "ES",
          },
        ],
      },
    ],
  },
  {
    key: "LK",
    label: "Sri Lanka",
  },
  {
    key: "SD",
    label: "Sudan",
  },
  {
    key: "SR",
    label: "Suriname",
  },
  {
    key: "SJ",
    label: "Svalbard and Jan Mayen",
  },
  {
    key: "SZ",
    label: "Swaziland",
  },
  {
    key: "SE",
    label: "Sweden",
  },
  {
    key: "CH",
    label: "Switzerland",
    types: [
      {
        id: "ch_vat",
        validations: [
          {
            regex: /^(CHE-\d{3}.\d{3}.\d{3} MWST)$/,
            examples: ["CHE-123.456.789 MWST"],
            prepend: "CHE-",
            append: " MWST",
          },
        ],
      },
      {
        id: "ch_uid",
        validations: [
          {
            regex: /^(CHE-\d{3}.\d{3}.\d{3} HR)$/,
            examples: ["CHE-123.456.789 HR"],
            prepend: "CHE-",
            append: " HR",
          },
        ],
      },
    ],
  },
  {
    key: "SY",
    label: "Syria",
  },
  {
    key: "TW",
    label: "Taiwan",
  },
  {
    key: "TJ",
    label: "Tajikistan",
  },
  {
    key: "TZ",
    label: "Tanzania",
  },
  {
    key: "TH",
    label: "Thailand",
  },
  {
    key: "TG",
    label: "Togo",
  },
  {
    key: "TK",
    label: "Tokelau",
  },
  {
    key: "TO",
    label: "Tonga",
  },
  {
    key: "TT",
    label: "Trinidad and Tobago",
  },
  {
    key: "TN",
    label: "Tunisia",
  },
  {
    key: "TR",
    label: "Turkey",
  },
  {
    key: "TM",
    label: "Turkmenistan",
  },
  {
    key: "TC",
    label: "Turks and Caicos Islands",
  },
  {
    key: "TV",
    label: "Tuvalu",
  },
  {
    key: "VI",
    label: "U.S. Virgin Islands",
  },
  {
    key: "UG",
    label: "Uganda",
  },
  {
    key: "UA",
    label: "Ukraine",
  },
  {
    key: "AE",
    label: "United Arab Emirates",
  },
  {
    key: "GB",
    label: "United Kingdom",
    types: [
      {
        id: "gb_vat",
        validations: [
          {
            regex: /^(GB\d{9})$/,
            examples: ["GB123456789"],
            prepend: "GB",
          },
        ],
      },
    ],
  },
  {
    key: "US",
    label: "United States",
    types: [
      {
        id: "us_ein",
        validations: [
          {
            regex: /^(\d{2}-\d{7})$/,
            examples: ["12-3456789"],
          },
        ],
      },
    ],
  },
  {
    key: "UM",
    label: "United States Minor Outlying Islands",
  },
  {
    key: "UY",
    label: "Uruguay",
  },
  {
    key: "UZ",
    label: "Uzbekistan",
  },
  {
    key: "VU",
    label: "Vanuatu",
  },
  {
    key: "VA",
    label: "Vatican",
  },
  {
    key: "VE",
    label: "Venezuela",
    /* types: [
      {
        id: 've_rif',
        validations: [
          {
            regex: /^([VEJPG]{1})-([0-9]{8})-([0-9]{1})$/,
            examples: ['J-12345678-9'],
          },
          {
            regex: /^([VEJPG]{1})-([0-9]{9})$/,
            examples: ['J-123456789'],
          },
        ],
      },
    ], */
  },
  {
    key: "VN",
    label: "Vietnam",
  },
  {
    key: "WF",
    label: "Wallis and Futuna",
  },
  {
    key: "EH",
    label: "Western Sahara",
  },
  {
    key: "YE",
    label: "Yemen",
  },
  {
    key: "ZM",
    label: "Zambia",
  },
  {
    key: "ZW",
    label: "Zimbabwe",
  },
].filter((c) => !!c.types);

export const COUNTRIES = Object.freeze(countries);
